/**
 * Observable pattern for updated properties.
 *
 * @param dataObj The object to observe.
 * @param watchList The array filter of properties.
 * @returns {{data: *, observe: _observe, notify: _notify, destroy: _destroy}}
 * @constructor
 * @example
 *  const watcher = Watcher(object, ['property_1', 'property_2']); // Create Observer.
 *  watcher.observe('property_1', doSomethingFunction); // Assign callback.
 */
export default function(dataObj, watchList) {
  let signals = {};

  function _observe(property, signalHandler) {
    if (!signals[property]) signals[property] = [];

    signals[property].push(signalHandler);
  }

  function _notify(signal) {
    if (!signals[signal] || signals[signal].length < 1) return;

    signals[signal].forEach(signalHandler => signalHandler());
  }

  function _destroy() {
    signals = {};
  }

  function makeReactive(key) {
    let val = dataObj[key];

    Object.defineProperty(dataObj, key, {
      get() {
        return val;
      },
      set(newVal) {
        val = newVal;
        _notify(key);
      }
    });
  }

  function observeData() {
    for (const key in dataObj) {
      if (
        dataObj.hasOwnProperty(key) &&
        typeof dataObj[key] !== "function" &&
        (!watchList || watchList.indexOf(key) !== -1)
      ) {
        makeReactive(key);
      }
    }
  }

  observeData();

  return {
    data: dataObj,
    observe: _observe,
    notify: _notify,
    destroy: _destroy
  };
}
